var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00016 0 80 0 80 80 0.00016 80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hifi",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19.-Conirmation-Message-2",
    transform: "translate(-360.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(360.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.00016,3.19944 C19.67616,3.19944 3.20016,19.67544 3.20016,39.99944 C3.19936,60.32344 19.67616,76.80024 40.00016,76.80024 C60.32416,76.80024 76.80016,60.32424 76.80016,39.99944 C76.77776,19.68504 60.31536,3.22264 40.00016,3.19944 M40.00016,80.00024 C17.90896,80.00024 0.00016,62.09144 0.00016,39.99944 C0.00016,17.90824 17.90816,-0.00056 40.00016,-0.00056 C62.09136,-0.00056 80.00016,17.90824 80.00016,39.99944 C79.97536,62.08104 62.08176,79.97464 40.00016,80.00024",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.40648,32.1084 C29.14168,32.1084 30.54888,33.5156 30.54888,35.2508 C30.54888,36.986 29.14168,38.3932 27.40648,38.3932 C25.67128,38.3932 24.26408,36.986 24.26408,35.2508 C24.26408,33.5156 25.67128,32.1084 27.40648,32.1084",
    id: "Fill-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.59392,32.1084 C54.32992,32.1084 55.73632,33.5156 55.73632,35.2508 C55.73632,36.986 54.32992,38.3932 52.59392,38.3932 C50.85872,38.3932 49.45152,36.986 49.45152,35.2508 C49.45152,33.5156 50.85872,32.1084 52.59392,32.1084",
    id: "Fill-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.95096,23.81624 C63.54696,23.09784 62.65896,22.80984 61.90936,23.15464 C59.65736,24.21864 57.11976,24.51944 54.68136,24.01064 C52.29576,23.29464 50.20776,21.81864 48.73656,19.80744 C48.20536,19.10504 47.20536,18.96664 46.50216,19.49704 C45.80056,20.02824 45.66136,21.02904 46.19256,21.73144 C46.19496,21.73384 46.19736,21.73704 46.19976,21.74024 C48.13816,24.29384 50.83496,26.16904 53.90376,27.09864 C54.86856,27.33064 55.85896,27.44664 56.85176,27.44264 C59.04376,27.41464 61.20856,26.94584 63.21656,26.06424 C64.01976,25.70904 64.38216,24.76904 64.02776,23.96664 C64.00376,23.91544 63.97896,23.86504 63.95096,23.81624",
    id: "Fill-8",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.37288,19.41504 C32.67448,18.97664 31.75688,19.14704 31.26328,19.80784 C29.79288,21.81824 27.70648,23.29344 25.32088,24.01024 C22.88168,24.51824 20.34328,24.21824 18.08968,23.15424 C17.34168,22.81024 16.45368,23.09744 16.04968,23.81504 C15.61048,24.57664 15.87208,25.54864 16.63288,25.98704 C16.68168,26.01504 16.73208,26.04144 16.78408,26.06384 C18.79128,26.94544 20.95608,27.41424 23.14808,27.4415044 C24.14568,27.44464 25.14088,27.32864 26.11128,27.09504 C29.17448,26.16464 31.86568,24.29024 33.80088,21.74064 C34.33688,21.04304 34.20488,20.04304 33.50648,19.50784 C33.46408,19.47424 33.41928,19.44384 33.37288,19.41504",
    id: "Fill-10",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.79552,52.50176 C56.60992,52.11856 56.27632,51.82496 55.87072,51.69136 C45.55472,48.30496 34.42752,48.29616 24.10672,51.66736 C23.68992,51.81056 23.35312,52.12096 23.17712,52.52496 C22.81792,53.33616 23.18432,54.28496 23.99632,54.64416 C24.36192,54.80496 24.77472,54.82416 25.15392,54.69856 C34.80832,51.58976 45.19552,51.59936 54.84512,54.72416 C55.01232,54.77936 55.18592,54.80816 55.36272,54.80816 C56.24592,54.80736 56.96032,54.09056 56.96032,53.20816 C56.96032,52.96336 56.90352,52.72176 56.79552,52.50256 L56.79552,52.50176 Z",
    id: "Fill-12",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotHappy);
export default __webpack_public_path__ + "static/media/not-happy.09f935148f907a304abd9e784894f10f.svg";
export { ForwardRef as ReactComponent };